<template>
  <div>
    <div class="app-block-group">
      <a :class="$route.path.split('/')[2] ? 'small app-block desktop' : 'large app-block desktop'"
        v-for="issue in copy.issues"
        :id="issue.image_name + '-block'"
        :href="'./index.html#/issues/'+issue.image_name+'#Toggle'">
        <div class="app-block-image">
          <img :src="'./assets/illustrations/'+issue.image_name+'.png'"></img>
        </div>
        <div class="app-block-text">
          <h5>{{ issue.category }}</h5>
        </div>
      </a>
    </div>
    <div class="container">
      <div :class="$route.path.split('/')[2] ? 'small app-block-group filter-bar mobile' : 'large app-block-group filter-bar mobile'">
        <select id="issueSelect" name="issueSelect" onchange="location = this.value;">
          <option v-for="issue in copy.issues"
            :value="'./index.html#/issues/'+issue.image_name"
            :selected="$route.path.split('/')[2] == issue.image_name ? 'selected' : ''">
            {{ issue.category }}
          </option>
        </select>
      </div>
    </div>
    <router-view v-bind:copy="copy"></router-view>
  </div>
</template>

<script>
  module.exports =  {
    name: 'issues',
    mounted: function() {
      var selected = this.$route.path.split('/')[2] + '-block';
      selected ? document.getElementById(selected).classList.add("selected") : '';
    },
    updated: function() {
      var selected = this.$route.path.split('/')[2] + '-block';
      document.getElementsByClassName("selected").length > 0 ? document.getElementsByClassName("selected")[0].classList.remove("selected") : '';
      selected ? document.getElementById(selected).classList.add("selected") : '';
    },
    props: ['copy']
  }
</script>

<style scoped></style>
